import * as S from './styles'
import { IButtonProps } from './types'

function Button(props: IButtonProps) {
	const { label, disabled = false, type, isLoading = false, onClick } = props

	return (
		<S.ButtonWrapper {...props}>
			<S.Button>
				{!isLoading ? label : 'Carregando...'}
			</S.Button>
		</S.ButtonWrapper>
	)
}

export { Button }
